module.exports = __webpack_public_path__ + "img/icon_error.8e4986a5.svg";